import script from "./SweetProtein.vue?vue&type=script&setup=true&lang=js"
export * from "./SweetProtein.vue?vue&type=script&setup=true&lang=js"

import "./SweetProtein.vue?vue&type=style&index=0&id=6c578e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c578e3a"]])

export default __exports__